exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table .small[data-v-289d77f5]{width:80px}.table .dot[data-v-289d77f5]{border:7px solid green;position:absolute;border-radius:50%;margin:25px}.table .dot.offline[data-v-289d77f5]{border:7px solid red}", ""]);

// exports
